import styled from 'styled-components';

import { colors } from '@style-guide/config';

const Wrapper = styled.div`
  background-color: ${colors.lightGray};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 0px 60px 0px;
  position: relative;
  width: 100%;
`;

Wrapper.displayName = 'Wrapper';

export default Wrapper;
